import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/hero/VideoComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/homepage/TextCTABanner.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/accessories/accessories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/description/product_description.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/downloads/download_list.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/faqs/faq_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/features/advanced_features.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/features/feature_difference.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/features/features_list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/product_breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/secondary_nav.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/slider/slideshow.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/components/product_details/specifications/specs.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1196675210/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
